/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { onServiceWorkerRegistered } from './utils/appUpdate'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {

    },
    registered (registration) {
      onServiceWorkerRegistered(registration)
    },
    cached () {
    },
    updatefound () {
    },
    updated () {
      // Yeni sürüm kurulumu utils/appUpdate.js'teki "controllerchange" dinleyicisiyle ele alınır.
    },
    offline () {
    },
    error (error) {
    }
  })
}
